import { getToken, getHospitalId } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Payload {
  patientId: string;
  hospitalId?: string;
}

export const getReportFromPatientIdApi = createAsyncThunk(
  'Get Report From Patient Id',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        // Backend requires hospitalId (multi-tenancy); default it from storage so
        // callers that only pass patientId still work. Explicit payload wins.
        body: JSON.stringify({ hospitalId: getHospitalId(), ...payload }),
      };
      let res = await fetch(REPORTS.GET_REPORT_FROM_PATIENT_ID_URL, requestOptions);

      // Check if the response is not okay (status is 400 or other errors)
      if (!res.ok) {
        const errorData = await res.json(); // Extract error message from the res
        return rejectWithValue(errorData.msg || 'Unable to Get Report Template');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
